/* ==========================================================================
   Ease Cushion — Caregivers page sections
   Scroll reveals + gallery carousel. Loaded with `defer`.
   Re-initialises on Shopify theme-editor events so everything keeps working
   while you edit sections in the customizer.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('.ec-rv:not([data-ec-seen]), .ec-pts:not([data-ec-seen])');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('ec-in');
        el.setAttribute('data-ec-seen', '');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ec-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    Array.prototype.forEach.call(items, function (el) {
      el.setAttribute('data-ec-seen', '');
      io.observe(el);
    });
  }

  /* ---------- gallery carousel ---------- */
  function initCarousel(el) {
    if (el.hasAttribute('data-ec-ready')) return;
    el.setAttribute('data-ec-ready', '');

    var track = el.querySelector('.ec-car__track');
    var prev = el.querySelector('[data-ec-prev]');
    var next = el.querySelector('[data-ec-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector('.ec-car__i');
      if (!item) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || 24) || 24;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll(root) {
    var scope = root || document;
    initReveals(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ec-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:reorder', function () { initAll(); });
})();
